module.exports = __webpack_public_path__ + "media/images/badgerart02-fe646d0251843dbc8203dbc1711046a1.png";